import React from 'react'
import { Layout, Spin } from 'antd'

const LoadingLayout = () => (
  <Layout>
    <section style={{
      height: '100vh', display: 'flex', alignItems: 'center', margin: 'auto',
    }}
    >
      <Spin tip="Loading..." />
    </section>
  </Layout>
)

export default LoadingLayout
